export default __webpack_public_path__ + "static/media/icon-collection.5adb0784.svg";